import { render, staticRenderFns } from "./roadmap.vue?vue&type=template&id=af2f40fa&scoped=true&"
import script from "./roadmap.vue?vue&type=script&lang=ts&"
export * from "./roadmap.vue?vue&type=script&lang=ts&"
import style0 from "./roadmap.vue?vue&type=style&index=0&id=af2f40fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af2f40fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VTimeline } from 'vuetify/lib/components/VTimeline';
import { VTimelineItem } from 'vuetify/lib/components/VTimeline';
installComponents(component, {VCard,VCardText,VCardTitle,VTimeline,VTimelineItem})
